<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="verAquisicaoListaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Em Aquisição</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="dados">
                        <div class="alert alert-info" v-if="dados.id_estoque_item">
                            <div class="lead">
                                {{ dados.search }}
                            </div>
                            #{{ dados.id_estoque_item }}
                        </div>

                        <div class="alert alert-info" v-else>
                            <div class="lead">
                                {{ dados.descricao }}
                            </div>
                            #{{ dados.id }}
                        </div>

                        <div class="row" v-if="dados.compra">
                            <div class="col col-12 col-md-6">
                                Aquisições
                                <ul class="list-group">
                                    <li class="list-group-item" v-for="(aqs, iax) in dados.compra.list_id_aqs" :key="iax">
                                        <a href="#" @click.prevent="ver_aquisicao(aqs)" class="card-link">#{{ aqs }}</a>
                                    </li>
                                </ul>
                            </div>
                            <div class="col col-12 col-md-6">
                                OCs
                                <ul class="list-group">
                                    <li class="list-group-item" v-for="(oc, iax) in dados.compra.ocs" :key="iax">
                                        <a href="#" @click.prevent="ver_oc(oc)" class="card-link">#{{ oc }}</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';

export default {
    data() {
        return { 
            dados: null, 
        }
    },

    methods: { 
        ver_aquisicao (aqs) {
            $('.modal').modal('hide');

            this.$router.push({ name: 'suprimentos', params: { aba: 'aquisicao', id: aqs } });
        },

        ver_oc (oc) {
            $('.modal').modal('hide');

            this.$router.push({ name: 'suprimentos', params: { aba: 'oc', id: oc } });
        },

        abrir(ocs) {
            this.dados = _.cloneDeep(ocs);
            $('#verAquisicaoListaModal').modal('show');
        },
    }
}
</script>
